import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { ExportDropdown } from "@/components/ui/ExportDropdown";
import { DollarSign, Package, TrendingDown } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function ExportsSection({ getCsvParams }) {
  const { t } = useTranslation();
  const { token } = useAuth();
  const API = process.env.REACT_APP_BACKEND_URL;

  const makeFetcher = (endpoint) => async () => {
    const r = await fetch(`${API}/api${endpoint}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!r.ok) throw new Error("Export failed");
    return r.blob();
  };

  const exports = [
    {
      key: "accounting",
      icon: DollarSign,
      iconClass: "text-green-500",
      bgClass: "bg-green-500/10",
      endpoint: `/reports/accounting?${getCsvParams()}`,
      filename: "contabilidade",
      title: "Relatório Contabilístico",
    },
    {
      key: "inventory",
      icon: Package,
      iconClass: "text-blue-500",
      bgClass: "bg-blue-500/10",
      endpoint: "/stock/export/inventory",
      filename: "inventario",
      title: "Inventário",
    },
    {
      key: "movements",
      icon: TrendingDown,
      iconClass: "text-amber-500",
      bgClass: "bg-amber-500/10",
      endpoint: "/stock/export/movements",
      filename: "movimentos_stock",
      title: "Movimentos de Stock",
    },
  ];

  return (
    <div className="space-y-4" data-testid="exports-section">
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {exports.map(({ key, icon: Icon, iconClass, bgClass, endpoint, filename, title }) => (
          <Card key={key} className="bg-card border-border/50 hover:border-primary/30 transition-colors">
            <CardContent className="py-6 space-y-4">
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg ${bgClass}`}><Icon className={`w-5 h-5 ${iconClass}`} /></div>
                <div>
                  <p className="font-bold">{t(`reports.exports.${key}`)}</p>
                  <p className="text-xs text-muted-foreground">{t(`reports.exports.${key}Desc`)}</p>
                </div>
              </div>
              <ExportDropdown
                fetchCSV={makeFetcher(endpoint)}
                filename={filename}
                title={title}
                label={t("reports.exports.exportCsv")}
                className="w-full"
              />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
